module.exports = __webpack_public_path__ + "5d8cec4f1f966878fa8bb9ead98e08db.svg";